import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

/** One design token: its SCSS name and the CSS custom property it maps to. */
export interface TokenEntry {
  token: string;
  cssVar: string;
}

/** Tokens grouped by their `// #region` category in `_themes.scss`. */
export type TokenGroups = Record<string, TokenEntry[]>;

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private http = inject(HttpClient);

  private tokensFilePath = 'assets/design_tokens.json';

  getTokens(): Promise<TokenGroups> {
    return firstValueFrom(this.http.get<TokenGroups>(this.tokensFilePath));
  }
}
